var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.loading,"opacity":"0.99"}},[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.userGroups,"footer-props":{
        'items-per-page-options': [25, 75, 100],
        'items-per-page-text': 'Mostrar',
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }